module.exports = __webpack_public_path__ + "img/reverseSide.3b3e89af.png";